import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './ImageAccordion.css';

interface Brand {
  name: string;
  color: string;
  gradient: string;
  image?: string;
  description: string;
  path: string;
}

const brands: Brand[] = [
  {
    name: 'rader',
    color: '#E8D2AE',
    gradient: 'linear-gradient(135deg, #E8D2AE 0%, #D4B896 100%)',
    description: 'Contemporary design with timeless appeal',
    path: '/brand/rader'
  },
  {
    name: 'elvang',
    color: '#8B6B82',
    gradient: 'linear-gradient(135deg, #8B6B82 0%, #A67C96 100%)', 
    description: 'Luxury textiles and premium materials',
    path: '/brand/elvang'
  },
  {
    name: 'gefu',
    color: '#7B4397',
    gradient: 'linear-gradient(135deg, #7B4397 0%, #DC2430 100%)',
    description: 'Innovative kitchen solutions',
    path: '/brand/gefu'
  },
  {
    name: 'remember',
    color: '#F7DC6F',
    gradient: 'linear-gradient(135deg, #F7DC6F 0%, #F4D03F 100%)',
    description: 'Memorable moments, beautiful memories',
    path: '/brand/remember'
  },
  {
    name: 'ppd',
    color: '#48CAE4',
    gradient: 'linear-gradient(135deg, #48CAE4 0%, #0096C7 100%)',
    description: 'Creative paper products',
    path: '/brand/ppd'
  },
  {
    name: 'relaxound',
    color: '#52B788',
    gradient: 'linear-gradient(135deg, #52B788 0%, #40916C 100%)',
    description: 'Sounds of nature, peace of mind',
    path: '/brand/relaxound'
  },
  {
    name: 'my flame lifestyle',
    color: '#FF8A80',
    gradient: 'linear-gradient(135deg, #FF8A80 0%, #FF5722 100%)',
    description: 'Candles and lifestyle products',
    path: '/brand/myflame'
  }
];

const ImageAccordion: React.FC = () => {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
  const navigate = useNavigate();

  const handleCardClick = (brand: Brand) => {
    navigate(brand.path);
  };

  return (
    <div className="image-accordion">
      {brands.map((brand, index) => (
        <div
          key={brand.name}
          className={`accordion-card ${hoveredIndex === index ? 'hovered' : ''} ${hoveredIndex !== null && hoveredIndex !== index ? 'dimmed' : ''}`}
          style={{
            background: brand.gradient,
            zIndex: hoveredIndex === index ? 10 : brands.length - index
          }}
          onMouseEnter={() => setHoveredIndex(index)}
          onMouseLeave={() => setHoveredIndex(null)}
          onClick={() => handleCardClick(brand)}
        >
          <div className="card-content">
            <div className="brand-title">
              <h2>{brand.name}</h2>
            </div>
            
            <div className="brand-info">
              <p className="brand-description">{brand.description}</p>
              <div className="explore-button">
                <span>explore &gt;</span>
              </div>
            </div>
          </div>
          
          <div className="card-overlay" />
        </div>
      ))}
    </div>
  );
};

export default ImageAccordion;